import {
	Directive,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	signal,
} from '@angular/core';
import {
	CollapsableBusinessSettingsSection,
	CollapsedChangeData,
	SectionCollapsedStates,
} from '../../business-finances-general.types';

@Directive()
export abstract class BaseBusinessSettingsSection implements OnChanges {
	@Input() sectionTitle: CollapsableBusinessSettingsSection;
	@Input() sectionCollapsedStates: SectionCollapsedStates;

	@Output() sectionCollapsedChanged = new EventEmitter<CollapsedChangeData>();

	public shouldCollapseSignal = signal(true);

	private sectionEnumKey: string;

	ngOnChanges(): void {
		const enumKeyForSection = this.getSectionEnumKey();

		if (
			this.sectionCollapsedStates &&
			enumKeyForSection in this.sectionCollapsedStates
		) {
			const shouldCollapse = this.sectionCollapsedStates[enumKeyForSection];
			this.shouldCollapseSignal.set(shouldCollapse);
		}
	}

	protected onCollapsedChange(collapsedState: boolean): void {
		this.sectionCollapsedChanged.emit({
			sectionName: this.sectionTitle,
			collapsed: collapsedState,
		});
	}

	protected getSectionEnumKey(): string {
		if (this.sectionEnumKey) return this.sectionEnumKey;

		const matchedEnumKey = Object.entries(CollapsableBusinessSettingsSection)
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			.find(([key, value]) => value === this.sectionTitle)?.[0];

		this.sectionEnumKey = matchedEnumKey;

		return matchedEnumKey;
	}
}
